export default "__VITE_ASSET__97123bbc__"